const keysMapped = {
  partnersDrawer: "ctrl+shift+p, cmd+shift+p"
}
export default keysMapped
